import { JSX } from 'react'

export const isChildNull = (children: JSX.Element, props: unknown) => {
  try {
    const data = children.type(props)
    return Boolean(data === null) || Object.keys(data).length === 0
  } catch {
    return true
  }
}
